import React, { useEffect, useRef, useState } from "react";
import Portal from "../../../../components/Portal";
import { Transaction } from "../../../../models/Transactions";
import { RecipientsFromTransaction, walletRepository } from "../../../../repositories/WalletRepository";
import { canManageMembers, Pleb, PlebData } from "../../../../models/Pleb";
import Loader from "../../components/Loader";
import { MemberListTile } from "../../components/MemberListTile";
import { ChatChannelType } from "../../../../models/ChatChannel";
import { useInView } from "react-intersection-observer";
import { useRouter } from "../../../../hooks/useRouter";
import { useAuth } from "../../../../hooks/useAuth";
import Modal from 'react-modal';
import { customStylesModal } from "../../../../components/ConfirmModal";

interface DialogTransactionRecipientsProps {
    transaction: Transaction;
    onClose: () => void;
}

const limitPerPage = 10;

export const DialogTransactionRecipients = ({transaction, onClose}: DialogTransactionRecipientsProps) => {
    const [count, setCount] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [recipients, setRecipients] = useState<Pleb[]>([]);
    const [loading, setLoading] = useState(false);
    const { ref, inView } = useInView();
    const offsetRef = useRef(0);
    const {navigateToProfile} = useRouter();
    const {pleb} = useAuth();

    useEffect(() => {
        if(inView && hasMore && !loading) {
            setLoading(true);
            walletRepository.getRecipientsFromTransaction(transaction.id, pleb?.id ?? '', limitPerPage, offsetRef.current)
                .then((recipientsData: RecipientsFromTransaction) => {
                    offsetRef.current += limitPerPage;
                    setCount(recipientsData.count);
                    setRecipients(prev => [...prev, ...recipientsData.transactions.flatMap((recipient) => recipient.recipient)]);
                    if(recipientsData.transactions.length == 0)
                        setHasMore(false);
                })
                .catch((err) => {
                    setHasMore(false);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [inView, hasMore, loading]);

    return (
        <Modal 
            isOpen={true} 
            onRequestClose={onClose}
            style={customStylesModal('500px', false, 999)}
        >
            {
                loading && recipients.length == 0 ? (
                    <div className="flex justify-center items-center py-4 min-h-[300px]"><Loader /></div>
                ) : (
                    <div className="flex flex-col py-4 gap-4">
                        <h1 className="text-xl font-bold text-center">Recipients</h1>
                        <div className="flex flex-col overflow-y-auto max-h-[50vh]">
                            {
                                recipients.map(recipient => (
                                <MemberListTile
                                    key={recipient.id}
                                    member={recipient}
                                    admin={false}
                                    onTap={() => navigateToProfile(ChatChannelType.Messaging, recipient.id)}
                                    allowPressAwaitingReply={(pleb && canManageMembers(pleb)) ? true : false}
                                />
                                ))
                            }
                            {loading && <div className="flex justify-center items-center py-4"><Loader small /></div>}
                            {hasMore && <div ref={ref} className="h-5" />}
                        </div>
                    </div>
                )
            }
        </Modal>
    );
}